import * as React from 'react';

import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const PlatformFAQ = () => {
  const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
  }));

  const AccordionSummary = styled((props: AccordionSummaryProps) => (
    <MuiAccordionSummary
      expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem', color: '#294f7ahd' }} />}
      {...props}
    />
  ))(({ theme }) => ({
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .05)' : 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
      marginLeft: theme.spacing(1),
    },
  }));

  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
  }));

  const [expanded, setExpanded] = React.useState<string | false>('panel1');

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      setExpanded(newExpanded ? panel : false);
    };

  const screensize = window.matchMedia('screen and (max-width: 500px)');

  return (
    <div>
      <div className='FAQContainer'>
        <div className='FAQTitle'>
          <span className='flx'>FLX</span>lease Real Estate Platform FAQ
        </div>
        <div className='FAQTitleDescription'>
          Welcome to the FLXlease Real Estate Platform FAQ section. Here, we&apos;ve compiled
          answers to some common questions about our online reservation inquiry platform,
          designed specifically for flexible leasing options of over 28+ days. If you have any
          further queries, feel free to reach out to our customer support team.
        </div>

        <Accordion
          className='accordionGrp'
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            aria-controls='panel1d-content'
            id='panel1d-header'
            style={{
              textAlign: 'left',
              border: 'solid #A4A6A7 1px',
              borderRadius: '2px',
              backgroundColor: '#FBFBFB',
            }}
          >
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1.1em',
                fontWeight: '500',
                color: '#294f7ahd',
                padding: '.3% 0',
              }}
            >
              1. What is FLXlease?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: screensize.matches ? '1em' : '1em',
                textAlign: 'left',
                padding: '1% 2%',
                fontWeight: '500',
              }}
            >
              FLXlease is an innovative online reservation inquiry platform catered to
              individuals seeking flexible leasing options for over 28+ days. Our platform
              connects prospective tenants with property owners, allowing users to send
              reservation inquiries for properties they are interested in. Property owners then
              respond individually to each inquiry to follow up on booking requests.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className='accordionGrp'
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            aria-controls='panel2d-content'
            id='panel2d-header'
            style={{
              textAlign: 'left',
              border: 'solid #A4A6A7 1px',
              borderRadius: '2px',
              backgroundColor: '#FBFBFB',
            }}
          >
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1.1em',
                fontWeight: '500',
                color: '#294f7ahd',
                padding: '.3% 0',
              }}
            >
              2. How does FLXlease work?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1em',
                textAlign: 'left',
                padding: '1% 2%',
                fontWeight: '500',
              }}
            >
              FLXlease simplifies the process of finding and securing flexible lease
              properties. Users can browse through a diverse range of rental properties listed
              on our platform, with lease durations of 28 days or more. When you find a
              property you&apos;re interested in, you can send a reservation inquiry directly
              to the property owner. The property owner will receive your inquiry and reach out
              to you individually to discuss the details of your booking request.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className='accordionGrp'
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            aria-controls='panel3d-content'
            id='panel3d-header'
            style={{
              textAlign: 'left',
              border: 'solid #A4A6A7 1px',
              borderRadius: '2px',
              backgroundColor: '#FBFBFB',
            }}
          >
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1.1em',
                fontWeight: '500',
                color: '#294f7ahd',
                padding: '.3% 0',
              }}
            >
              3. Is FLXlease only for long-term rentals?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1em',
                textAlign: 'left',
                padding: '1% 2%',
                fontWeight: '500',
              }}
            >
              Yes, FLXlease is specifically tailored for long-term rentals with lease durations
              of 28 days or more. Whether you&apos;re relocating, traveling for work, or simply
              need a longer- term accommodation solution, FLXlease provides a wide selection of
              properties to choose from.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className='accordionGrp'
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            aria-controls='panel4d-content'
            id='panel4d-header'
            style={{
              textAlign: 'left',
              border: 'solid #A4A6A7 1px',
              borderRadius: '2px',
              backgroundColor: '#FBFBFB',
            }}
          >
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1.1em',
                fontWeight: '500',
                color: '#294f7ahd',
                padding: '.3% 0',
              }}
            >
              4. In how many cities is FLXlease available?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1em',
                textAlign: 'left',
                padding: '1% 2%',
                fontWeight: '500',
              }}
            >
              FLXlease operates in 57 major cities nationwide, making it convenient for
              individuals to find flexible lease options in various locations across the
              country. Our platform is designed to help you secure comfortable and suitable
              accommodations no matter where you need to be.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className='accordionGrp'
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            aria-controls='panel5d-content'
            id='panel5d-header'
            style={{
              textAlign: 'left',
              border: 'solid #A4A6A7 1px',
              borderRadius: '2px',
              backgroundColor: '#FBFBFB',
            }}
          >
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1.1em',
                fontWeight: '500',
                color: '#294f7ahd',
                padding: '.3% 0',
              }}
            >
              5. How do I send a reservation inquiry?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1em',
                textAlign: 'left',
                padding: '1% 2%',
                fontWeight: '500',
              }}
            >
              Sending a reservation inquiry on FLXlease is easy. Once you&apos;ve identified a
              property you&apos;re interested in, simply click on the &quot;Send Inquiry&quot;
              button on the property&apos;s listing page. You&apos;ll be prompted to provide
              some basic information, and your inquiry will be forwarded to the property owner.
              They will then contact you directly to discuss your inquiry further.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className='accordionGrp'
          expanded={expanded === 'panel6'}
          onChange={handleChange('panel6')}
        >
          <AccordionSummary
            aria-controls='panel6d-content'
            id='panel6d-header'
            style={{
              textAlign: 'left',
              border: 'solid #A4A6A7 1px',
              borderRadius: '2px',
              backgroundColor: '#FBFBFB',
            }}
          >
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1.1em',
                fontWeight: '500',
                color: '#294f7ahd',
                padding: '.3% 0',
              }}
            >
              6. What happens after I send a reservation inquiry?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1em',
                textAlign: 'left',
                padding: '1% 2%',
                fontWeight: '500',
              }}
            >
              After sending a reservation inquiry, the property owner will receive your request
              and review the information you provided. They will then reach out to you
              individually via the contact information you provided. You can expect to discuss
              details such as availability, rental terms, property viewings, and any other
              questions you may have.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className='accordionGrp'
          expanded={expanded === 'panel7'}
          onChange={handleChange('panel7')}
        >
          <AccordionSummary
            aria-controls='panel7d-content'
            id='panel7d-header'
            style={{
              textAlign: 'left',
              border: 'solid #A4A6A7 1px',
              borderRadius: '2px',
              backgroundColor: '#FBFBFB',
            }}
          >
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1.1em',
                fontWeight: '500',
                color: '#294f7ahd',
                padding: '.3% 0',
              }}
            >
              7. Can I send inquiries for multiple properties?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1em',
                textAlign: 'left',
                padding: '1% 2%',
                fontWeight: '500',
              }}
            >
              Yes, you can send reservation inquiries for multiple properties that catch your
              interest. This allows you to explore different options and engage with multiple
              property owners simultaneously. Keep in mind that each property owner will
              respond individually, so you&apos;ll have the opportunity to communicate directly
              with each owner.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className='accordionGrp'
          expanded={expanded === 'panel8'}
          onChange={handleChange('panel8')}
        >
          <AccordionSummary
            aria-controls='panel8d-content'
            id='panel8d-header'
            style={{
              textAlign: 'left',
              border: 'solid #A4A6A7 1px',
              borderRadius: '2px',
              backgroundColor: '#FBFBFB',
            }}
          >
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1.1em',
                fontWeight: '500',
                color: '#294f7ahd',
                padding: '.3% 0',
              }}
            >
              8. Is there a fee for sending reservation inquiries?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1em',
                textAlign: 'left',
                padding: '1% 2%',
                fontWeight: '500',
              }}
            >
              No, there is no fee for sending reservation inquiries through the FLXlease
              platform. It&#39;s completely free to browse listings, send inquiries, and
              initiate contact with property owners.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className='accordionGrp'
          expanded={expanded === 'panel9'}
          onChange={handleChange('panel9')}
        >
          <AccordionSummary
            aria-controls='panel9d-content'
            id='panel9d-header'
            style={{
              textAlign: 'left',
              border: 'solid #A4A6A7 1px',
              borderRadius: '2px',
              backgroundColor: '#FBFBFB',
            }}
          >
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1.1em',
                fontWeight: '500',
                color: '#294f7ahd',
                padding: '.3% 0',
              }}
            >
              9. How long does it take for property owners to respond to inquiries?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1em',
                textAlign: 'left',
                padding: '1% 2%',
                fontWeight: '500',
              }}
            >
              Response times can vary depending on individual property owners. Some owners
              might respond within a few hours, while others may take up to a day or two. We
              encourage property owners to respond promptly to inquiries to provide a smooth
              experience for renters.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className='accordionGrp'
          expanded={expanded === 'panel10'}
          onChange={handleChange('panel10')}
        >
          <AccordionSummary
            aria-controls='panel10d-content'
            id='panel10d-header'
            style={{
              textAlign: 'left',
              border: 'solid #A4A6A7 1px',
              borderRadius: '2px',
              backgroundColor: '#FBFBFB',
            }}
          >
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1.1em',
                fontWeight: '500',
                color: '#294f7ahd',
                padding: '.3% 0',
              }}
            >
              10. What if I have technical issues or need further assistance?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              sx={{
                fontSize: screensize.matches ? '1.05em' : '1em',
                textAlign: 'left',
                padding: '1% 2%',
                fontWeight: '500',
              }}
            >
              If you encounter any technical issues while using FLXlease or if you need
              additional assistance, please contact our customer support team. You can reach us
              through the &quot;Support&quot; section of the platform, and we&apos;ll be happy
              to assist you with any concerns or questions you may have.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <div className='FAQEnd'>
          We hope these FAQs have provided clarity about how FLXlease works. If you have any
          other inquiries or need more information, don&apos;t hesitate to get in touch with
          us. Happy property hunting!
        </div>
      </div>
    </div>
  );
};
export default PlatformFAQ;
